import { money } from './DataTable';

/**
 * 청구액 부가세 — 별도(기본) / 포함 (#87, 2026-09-30 최우석 「부가세포함으로 청구가 필요한 거래처가 있습니다」).
 *
 * 포함이면 입력한 값이 **부가세포함가**다. 서버가 공급가 = ⌈값 ÷ 1.1⌉ 로 청구액을 두고 포함가를 따로 적는다
 * (`functions/src/disptWrite.ts splitVat` — 레거시 실측 1,200,000 → 1,090,910). 세금계산서는 포함가가 있으면
 * 합계 = 포함가라 600,000 이 599,999 로 깎이지 않는다.
 * 🔴 여기 계산은 **보여 주기용**이다. 저장값은 서버가 정한다 — 식을 바꾸면 서버 `splitVat` 과 같이 바꿀 것.
 */
export function vatSplit(text: string | null | undefined, incl: boolean) {
  const s = String(text ?? '').replace(/,/g, '').trim();
  if (s === '') return null;
  const x = Number(s);
  if (!Number.isFinite(x)) return null;
  if (incl) {
    const supply = x >= 0 ? Math.floor((x * 10 + 10) / 11) : -Math.floor((-x * 10 + 10) / 11);
    return { supply, vat: x - supply, total: x };
  }
  const vat = Math.trunc(x / 10);
  return { supply: x, vat, total: x + vat };
}

/** 노선 금액이 포함가로 저장돼 있나 — 포함가가 있고 공급가×1.1 과 다르면 포함(레거시 「별도」 줄도 ×1.1 을 적어 뒀다). */
export function isVatIncl(cost: unknown, addTax: unknown): boolean {
  const t = Number(addTax ?? 0);
  if (!t) return false;
  return t !== Math.round(Number(cost ?? 0) * 1.1);
}

export function VatToggle({ value, onChange, disabled }: { value: boolean; onChange: (v: boolean) => void; disabled?: boolean }) {
  return (
    <span className="inline-flex overflow-hidden rounded-md border border-line text-xs">
      {([[false, '부가세 별도'], [true, '부가세 포함']] as const).map(([v, label]) => (
        <button
          key={label}
          type="button"
          disabled={disabled}
          onClick={() => onChange(v)}
          className={`px-2 py-0.5 ${value === v ? 'bg-brand-600 text-white' : 'bg-surface text-ink-soft hover:bg-canvas'}`}
        >
          {label}
        </button>
      ))}
    </span>
  );
}

/** 입력값 옆에 두는 비교 한 줄 — 공급가 · 부가세 · 합계. */
export function VatPreview({ text, incl }: { text: string | null | undefined; incl: boolean }) {
  const v = vatSplit(text, incl);
  if (!v) return null;
  return (
    <span className="text-xs tabular-nums text-ink-faint">
      공급가 {money(v.supply)} · 부가세 {money(v.vat)} · 합계 <b className="text-ink-soft">{money(v.total)}</b>
    </span>
  );
}
